import { useScrollReveal } from '@/hooks/useScrollReveal';
import YouTubeFacade from '@/components/YouTubeFacade';

const LSO_URL = 'https://lawsocietyontario-dwd0dscmayfwh7bj.a01.azurefd.net/media/lso/media/lawyers/practice-supports-resources/generative-ai-your-professional-obligations.pdf';

const LegalAccountability = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-accountability-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-accountability-h2">
          Careful work with no way to show it
        </h2>

        <div className="legal-passage mt-8">
          <p className="legal-body" data-testid="legal-accountability-p1">
            Months after a matter closes, someone may ask how a piece of AI-assisted work was produced. A client. Co-counsel. A partner reviewing the file.
          </p>
          <p className="legal-body mt-6" data-testid="legal-accountability-p2">
            You were careful. But the record of how you got there sits in browser history, scattered notes, and memory. The work was sound. Showing that it was sound has become a reconstruction project.
          </p>
          <p className="legal-body mt-6" data-testid="legal-accountability-p3">
            Soundboard Matter is built so that record is produced as a consequence of doing the work: what informed it, which sources were used, whether anything was processed outside your environment, where you reviewed it, and what you approved.
          </p>
          <p className="legal-body mt-6" data-testid="legal-accountability-p4">
            That does not replace professional responsibility. Nothing does. It makes the responsibility you already carry visible, reviewable, and defensible.
          </p>
        </div>

        <p className="legal-body mt-8" data-testid="legal-accountability-lso">
          The Law Society of Ontario has <a href={LSO_URL} target="_blank" rel="noopener noreferrer" className="legal-inline-link">published guidance</a> on the use of generative AI in practice, describing expectations around human verification, records of inputs and outputs, confidentiality controls, supervision, and documentation. Soundboard Matter is designed to support those practices. Responsibility for meeting professional obligations remains with the licensee, and no software can discharge it.
        </p>
      </div>

      <div className="legal-content-wide mt-14">
        <YouTubeFacade
          videoId="WX9iGdbsqXc"
          heading="AI turned your process into a question"
          caption="Why the accountability question is new, and why no existing habit was designed to answer it."
          title="AI turned your process into a question"
        />
      </div>
    </section>
  );
};

export default LegalAccountability;
